import { JSX } from 'preact';

type IImageProps = JSX.IntrinsicElements['img'] & {
	fallbackImage?: string;
	handleImageError?: () => void;
};

type IImageErrorEvent = JSX.TargetedEvent<HTMLImageElement, Event>;

const Image = ({
	fallbackImage,
	src,
	alt,
	handleImageError,
	...rest
}: IImageProps) => {
	const handleError = (event: IImageErrorEvent) => {
		const imageElement = event.currentTarget;
		const didAlreadyTryFallback = imageElement.src === fallbackImage;

		if (fallbackImage && !didAlreadyTryFallback) {
			imageElement.src = fallbackImage;
			return;
		}

		handleImageError?.();
	};

	return <img src={src} alt={alt} onError={handleError} {...rest} />;
};

export default Image;
